(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffb-product-specs-faq"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ffb-spec-switch')) {
  customElements.define('ffb-spec-switch', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.items = [...this.querySelectorAll('.ffb-switch-item')];
      this.host = this.querySelector('[data-image-host]');
      this.galleries = this.items.map(item => ({
        item, slot: item.querySelector('[data-image-slot]'),
        gallery: item.querySelector('[data-gallery]')
      }));
      this.current = this.items.find(item => item.open) || this.items[0];
      this.media = matchMedia('(min-width: 990px)');
      this.items.forEach(item => {
        item.querySelector('summary').addEventListener('click', event => {
          event.preventDefault();
          this.activate(item);
        }, {signal: this.controller.signal});
        item.addEventListener('toggle', () => {
          if (item.open && item !== this.current) this.activate(item);
        }, {signal: this.controller.signal});
      });
      this.media.addEventListener('change', () => this.layout(), {signal:this.controller.signal});
      this.setAttribute('data-enhanced', '');
      this.layout();
    }
    activate(item) {
      this.current = item;
      this.items.forEach(other => { other.open = other === item; });
      this.galleries.forEach(entry => {
        if (entry.gallery) entry.gallery.hidden = this.media.matches && entry.item !== item;
      });
      const hasGallery = this.galleries.some(entry => entry.item === item && entry.gallery);
      this.host.hidden = !this.media.matches || !hasGallery;
      this.toggleAttribute('data-no-images', !hasGallery);
      this.dispatchEvent(new Event('toggle', {bubbles:true}));
    }
    layout() {
      this.galleries.forEach(entry => {
        if (!entry.gallery) return;
        const destination = this.media.matches ? this.host : entry.slot;
        if (entry.gallery.parentElement !== destination) destination.append(entry.gallery);
      });
      this.activate(this.current);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      // Restore original placement before Shopify reconnects this section.
      this.galleries?.forEach(entry => {
        if (entry.gallery) { entry.slot.append(entry.gallery); entry.gallery.hidden = false; }
      });
      this.removeAttribute('data-enhanced');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
